import {makeStyles} from "@mui/styles";

export const useStylesDialog = makeStyles(() => ({
    dialog: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "75%",
        marginRight: 0,
    },
    dialog50: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "50%",
    },
    dialogAlert: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "30%",
    },
    dialogConfirm: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "50%",
    },
    appBar: {
        position: "inherit",
        background: "linear-gradient(90deg, #0D1B2A 0%, #1B3A5C 100%)",
    },
    title: {
        marginLeft: 2,
        flex: 1,
    },
    highlight: {
        display: "inline",
        color: "#42A5F5",
    },
    formControl: {
        width: "100%",
    },
}));
